import styled from "styled-components";

export const ServicesContainer = styled.section`
    width: 100%;
    z-index: 999;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    padding: ${props => props.padd}rem 10rem;

    @media screen and (max-width: 480px) {
        margin: 50% 5% 15% 5%;   
        padding: 7.5rem 1rem 2rem 1rem;
    }
`;

export const TitleServices = styled.header`
    width: 30%;
    h2{
        font: 2.25rem/1 'Titan One',arial,sans-serif;
        color: ${props => props.titleColor};
    }
    p{
        margin: 1.25rem 0;
        font: .85rem/1.2 'Varela Round',arial,sans-serif;
        color: #656A72;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
    }
`;

export const ServicesWrapper = styled.article`
    width: 65%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    @media screen and (max-width: 480px) {
        width: 100%;
        margin-top: 25%;

        align-items: center;
        justify-content: center;
    }
`;